var _rect, _rect2, _rect3, _rect4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoLt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.46436,
    y: 11.5537,
    width: 14.3114,
    height: 3.48515,
    rx: 1.74258,
    transform: "rotate(45 2.46436 11.5537)",
    fill: "#00A253"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13.9736,
    y: 15.46,
    width: 14.3114,
    height: 3.48515,
    rx: 1.74258,
    transform: "rotate(45 13.9736 15.46)",
    fill: "#00A253"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 14.9175,
    y: 8.80078,
    width: 14.3114,
    height: 3.48515,
    rx: 1.74258,
    transform: "rotate(45 14.9175 8.80078)",
    fill: "#00A253"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 16.2803,
    y: 2.56055,
    width: 9.86223,
    height: 3.48515,
    rx: 1.74258,
    transform: "rotate(45 16.2803 2.56055)",
    fill: "#00A253"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLt);
export default __webpack_public_path__ + "static/media/logo-lt.8270fd544d11cd75b47c6c5095518597.svg";
export { ForwardRef as ReactComponent };